// 导入自定义 Layout 布局
import { BaseLayout, RouterView } from '@/layouts'

// 基础路由
export const routes = [
  {
    path: '/',
    redirect: '/admin'
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/user/Login')
  },
  {
    path: '/home',
    name: '首页',
    component: () => import('@/views/Home')
  }
]

// 管理后台
export const adminRoutes = [
  {
    path: '/admin',
    redirect: '/admin-home',
    component: BaseLayout,
    meta: { title: '管理后台', keepAlive: false },
    children: [
      {
        path: '/admin-home',
        name: 'AdminHome',
        component: () => import('@/views/admin/home/Home'),
        meta: { title: '首页', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 }
      },
      {
        path: '/admin-content',
        redirect: '/admin-filmlibrary',
        component: RouterView,
        meta: { title: '内容管理', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/admin-filmlibrary',
            name: 'AdminFilmlibrary',
            component: () => import('@/views/admin/content/Filmlibrary'),
            meta: { title: '片库', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      },
      {
        path: '/admin-wemedia',
        redirect: '/admin-youtube-filmlibrary',
        component: RouterView,
        meta: { title: '自媒体管理', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/admin-youtube-filmlibrary',
            name: 'AdminYoutubeFilmlibrary',
            component: () => import('@/views/admin/wemedia/YoutubeFilmlibrary'),
            meta: { title: '油管片库', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-video-translation-task',
            name: 'AdminVideoTranslationTask',
            component: () => import('@/views/admin/wemedia/VideoTranslationTask'),
            meta: { title: '视频翻译任务', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-wemedia-accounts',
            name: 'AdminWemediaAccount',
            component: () => import('@/views/admin/wemedia/Accounts'),
            meta: { title: '账号管理', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-timbre-library',
            name: 'AdminTimbreLibrary',
            component: () => import('@/views/admin/settings/TimbreLibrary'),
            meta: { title: '音色库', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      },
      {
        path: '/admin-promotion',
        redirect: '/admin-service-provider',
        component: RouterView,
        meta: { title: '推广管理', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/admin-service-provider',
            name: 'AdminServiceProvider',
            component: () => import('@/views/admin/promotion/ServiceProvider'),
            meta: { title: '服务商管理', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-promotion-link',
            name: 'AdminPromotionLink',
            component: () => import('@/views/admin/promotion/PromotionLink'),
            meta: { title: '推广链接', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-talent-record',
            name: 'AdminTalentRecord',
            component: () => import('@/views/admin/promotion/TalentRecord'),
            meta: { title: '达人备案', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      },
      {
        path: '/admin-supporting',
        redirect: '/admin-filmlibrary',
        component: RouterView,
        meta: { title: '配套设置', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/admin-languages',
            name: 'AdminLanguages',
            component: () => import('@/views/admin/supporting/Languages'),
            meta: { title: '界面语种管理', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-plottypes',
            name: 'AdminPlotTypes',
            component: () => import('@/views/admin/supporting/PlotTypes'),
            meta: { title: '剧情类型', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-plottags',
            name: 'AdminPlotTags',
            component: () => import('@/views/admin/supporting/PlotTags'),
            meta: { title: '剧情标签', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-products',
            name: 'AdminProducts',
            component: () => import('@/views/admin/supporting/Products'),
            meta: { title: '商品库', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-recharge-panel',
            name: 'AdminRechargePanel',
            component: () => import('@/views/admin/supporting/RechargePanel'),
            meta: { title: '自定义充值模板', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-version-update',
            name: 'AdminVersionUpdate',
            component: () => import('@/views/admin/supporting/VersionUpdate'),
            meta: { title: '版本更新策略', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-suppliers',
            name: 'AdminSuppliers',
            component: () => import('@/views/admin/supporting/Suppliers'),
            meta: { title: '成片供应商', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      },
      {
        path: '/admin-account',
        redirect: '/admin-register',
        component: RouterView,
        meta: { title: '用户管理', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/admin-register',
            name: 'AdminRegister',
            component: () => import('@/views/admin/account/Register'),
            meta: { title: '注册用户', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-purchase-record',
            name: 'AdminPurchaseRecord',
            component: () => import('@/views/admin/account/PurchaseRecord'),
            meta: { title: '购买记录', keepAlive: false, icon: 'PushpinOutlined' }
          },
        ]
      },
      {
        path: '/admin-settings',
        redirect: '/admin-accounts',
        component: RouterView,
        meta: { title: '系统设置', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/admin-accounts',
            name: 'AdminAccounts',
            component: () => import('@/views/admin/settings/Accounts'),
            meta: { title: '账号管理', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-gl-permission',
            name: 'AdminPermission',
            component: () => import('@/views/admin/settings/AdminPermission'),
            meta: { title: '管理后台权限', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/admin-yy-permission',
            name: 'AppfrontPermission',
            component: () => import('@/views/admin/settings/AppfrontPermission'),
            meta: { title: '前台管理权限', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      }
    ]
  }
]

// 运营中心
export const appfrontRoutes = [
  {
    path: '/appfront',
    redirect: '/appfront-home',
    component: BaseLayout,
    meta: { title: '前台管理', keepAlive: false, hasDropdown: true, dropdownOption: 'lang' },
    children: [
      {
        path: '/appfront-home',
        name: 'AppfrontHome',
        component: () => import('@/views/appfront/home/Home'),
        meta: { title: '首页', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 }
      },
      {
        path: '/appfront-content',
        redirect: '/appfront-film-library',
        component: RouterView,
        meta: { title: '内容管理', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/appfront-film-library',
            name: 'AppfrontFilmLibrary',
            component: () => import('@/views/appfront/content/FilmLibrary'),
            meta: { title: '片库', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/appfront-waitlibrary',
            name: 'AppfrontWaitLibrary',
            component: () => import('@/views/appfront/content/WaitLibrary'),
            meta: { title: '待入库', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      },
      {
        path: '/appfront-config',
        redirect: '/appfront-banners',
        component: RouterView,
        meta: { title: '前台配置', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/appfront-banners',
            name: 'AppfrontBanners',
            component: () => import('@/views/appfront/config/Banners'),
            meta: { title: '首页Banner', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/appfront-home-blocks',
            name: 'AppfrontHomeBlocks',
            component: () => import('@/views/appfront/config/HomeBlocks'),
            meta: { title: '首页分类板块', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/appfront-recharge-unlock',
            name: 'AppfrontRechargeUnlock',
            component: () => import('@/views/appfront/config/RechargeUnlock'),
            meta: { title: '充值解锁相关', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      }
    ]
  }
]
